import { useTranslation } from "react-i18next";
import careBalanceService from "../../services/careBalanceService";
import { getFullName } from "./utils/get-full-name";
import { useState } from "react";

const rightArtifact = "/img/wallet/activate-care-balance-right-artifact.png";
const bottomArtifact = "/img/wallet/activate-care-balance-bottom-artifact.png";

function Artifacts() {
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: "0",
          right: "0",
          bottom: "0",
          width: "30%",
          backgroundImage: `url(${rightArtifact})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right center",
        }}
      />

      <div
        style={{
          backgroundImage: `url(${bottomArtifact})`,
          backgroundSize: "cover",
          backgroundRepeat: "repeat-x",
          backgroundPosition: "center bottom",
          minHeight: "6px",
          position: "absolute",
          bottom: "0",
          left: "0",
          right: "0",
        }}
      />
    </>
  );
}

export default function ActivateCare({
  firstName,
  lastName,
  hmoId,
  setLoading,
  loading,
}) {
  const { t } = useTranslation("careBalance");
  const [disabled, setDisabled] = useState(false);

  const activeCareHandler = () => {
    if (!hmoId) {
      return;
    }

    setLoading(true);
    setDisabled(true);

    const payload = {
      name: getFullName(firstName, lastName),
      owner: hmoId,
      category: "enrollee",
      currency: "NGN",
      negativeBalance: false,
    };

    careBalanceService
      .activate(payload)
      .then(() => {
        location.reload();
      })
      .catch((error) => {
        setLoading(false);
        setDisabled(false);
        console.error(error);
      });
  };

  return (
    <div
      style={{
        minHeight: "114.72px",
        backgroundColor: "#404592",
        borderRadius: "17.21px",
        paddingBlock: "22.94px",
        paddingInline: "25.81px",
        position: "relative",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        rowGap: "4px",
        marginBottom: "16px",
      }}
      data-testid="activate-care-balance-card"
    >
      <Artifacts />

      <h2
        style={{
          color: "#FFEDFE",
          fontSize: "1.864rem",
          lineHeight: "2.581rem",
          letterSpacing: "-0.14px",
          fontWeight: "600",
        }}
      >
        {t("activateCareBalanceTitle")}
      </h2>

      <p
        style={{
          color: "#FFEDFE",
          fontSize: "1.291rem",
          lineHeight: "100%",
          letterSpacing: "-0.14px",
          fontWeight: "400",
          maxWidth: "680px",
        }}
      >
        {t("activateCareBalanceDescription")}
      </p>

      <button
        style={{
          backgroundColor: "#00AD60",
          color: "#FFFFFF",
          fontSize: "1.147rem",
          lineHeight: "2.581rem",
          letterSpacing: "-0.14px",
          fontWeight: "500",
          borderRadius: "8.5px",
          paddingInline: "10px",
          display: "flex",
          alignItems: "center",
        }}
        onClick={activeCareHandler}
        disabled={loading || disabled}
        data-testid="activate-care-balance-button"
      >
        {t("activateCareButtonLabel")}
      </button>
    </div>
  );
}
